import * as React from 'react';
import { makeStyles, styled } from '@material-ui/core/styles';
import { colors } from './common';
export var StateLine = function () {
    var classes = useStateStyles();
    return React.createElement("div", { className: classes.stateLine });
};
export var State = function (_a) {
    var children = _a.children, color = _a.color, checked = _a.checked;
    var classes = State.useStyles({ color: color, checked: checked });
    return (React.createElement("div", { className: classes.root },
        React.createElement("div", { className: classes.circle }, checked ? React.createElement("div", { className: classes.checked }) : void 0),
        React.createElement("div", { className: classes.label }, children)));
};
State.useStyles = makeStyles({
    root: {
        margin: '8px 4px 8px 4px',
        height: 39,
        position: 'relative'
    },
    checked: {
        color: colors.green,
        height: 5,
        borderWidth: '0 0 1px 1px',
        borderColor: colors.green,
        borderStyle: 'solid',
        width: 9,
        margin: '4px 3px 3px 3px',
        transform: 'rotate(-45deg)',
    },
    circle: {
        width: '17px',
        height: '17px',
        borderRadius: '50%',
        borderColor: function (_a) {
            var color = _a.color;
            return colors[color];
        },
        //backgroundColor: ({ color, checked } : any ) => checked ? colors[ color ] : '#fff',
        border: '1px solid #668aa5',
    },
    label: {
        marginTop: '8px',
        position: 'absolute',
        transform: 'translateX(-50%)',
        left: '50%',
        color: function (_a) {
            var color = _a.color;
            return color === 'blue' ? colors[color] : colors['grey'];
        },
        fontFamily: 'Montserrat',
        fontSize: 11,
        textAlign: 'center',
    }
});
export var StateFlow = styled('div')({
    display: "flex",
    justifyContent: 'center',
    alignContent: 'center',
    paddingLeft: 30,
    paddingRight: 30
});
var useStateStyles = makeStyles({
    stateLine: {
        height: '4px',
        borderRadius: '2px',
        width: 30,
        backgroundColor: '#e5f2fa',
        marginTop: 15
    }
});
//# sourceMappingURL=stateFlow.js.map